import { render } from "./sensor-attribute-item.vue?vue&type=template&id=73887a5e"
import script from "./sensor-attribute-item.vue?vue&type=script&lang=js"
export * from "./sensor-attribute-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__